import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Toolbar, AppBar, Link, } from "@material-ui/core";
import { Link as RouterLink  } from "react-router-dom";
import * as paths from "./../../Routes/paths";

const styles = makeStyles((theme) => ({
  appBar: {
    position: "absolute",
  },
  toolbarStyles: {
    height: 64,
    [theme.breakpoints.up('sm')]: {
      height: 70,
    },
  },
  appBarStyle: {
    color: theme.palette.grey[500],
  },
  title: {
    fontSize: 16,
    color: theme.palette.grey[500],
  },
  left: {
    flex: 1,
  },
  leftLinkActive: {
    color: theme.palette.grey[500],
  },
  right: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  rightLink: {
    fontSize: 16,
    color: theme.palette.grey[500],
    marginLeft: theme.spacing(3),
  },
  linkSecondary: {
    color: theme.palette.secondary.main,
  },
}))


const Header = () => {
  const classes = styles();
  return(
    <div>
      <AppBar elevation={0} color="transparent" className={classes.appBar}>
        <Toolbar className={classes.toolbarStyles}>
          <Link
            component={RouterLink}
            to={paths.HOMEPAGE}
            variant="h6"
            underline="none"
            color="inherit"
            className={classes.title}
          >
            Betastore
          </Link>
          <div className={classes.right}>
            <Link
              component={RouterLink}
              to={paths.LOGIN}
              color="inherit"
              variant="h6"
              underline="none"
              className={classes.rightLink}
            >
              {'Sign In'}
            </Link>
            <Link
              component={RouterLink}
              to={paths.REGISTER}
              variant="h6"
              underline="none"
              className={clsx(classes.rightLink, classes.linkSecondary)}
            >
              {'Sign Up'}
            </Link>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default Header